import InteresHistoricoSimpleTable from "./InteresHistoricoSimpleTable";

export {InteresHistoricoSimpleTable}
export default InteresHistoricoSimpleTable
